import React from 'react'

interface ArrowLeftIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
  opacity?: number
}

const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Arrow left icon',
  opacity = 0.87,
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: opacity }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: opacity }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillOpacity={gradient ? 1 : opacity}
        fillRule='evenodd'
        d='M14 7l-5 5 5 5V7z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default ArrowLeftIcon
